import { Link, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { useContext } from "react";
import { auth } from "../firebase/config";
import { AuthContext } from "../AuthContext";

export default function Navbar() {
  const navigate = useNavigate();
  const { user, isAdmin, isGuest, logoutGuest } = useContext(AuthContext);

  const handleLogout = () => {
    if (isGuest) {
      logoutGuest();
    } else {
      signOut(auth);
    }
    navigate("/");
  };


  if (!user) return null; // hide navbar when logged out

  return (
    <nav style={styles.nav}>
      <div style={styles.left}>
        <Link to="/dashboard" style={styles.link}>Classroom Companion</Link>
        <Link to="/classes" style={styles.link}>Classes</Link>
        <Link to="/analytics" style={styles.link}>Analytics</Link>
        <Link to="/feedback" style={styles.link}>Feedback</Link>
        {isAdmin && (
          <>
            <Link to="/admin/feedback" style={styles.link}>Admin Inbox</Link>
            <Link to="/admin/users" style={styles.link}>Admin Users</Link>
            <Link to="/admin/analytics" style={styles.link}>Admin Analytics</Link>
            <Link to="/admin/sar" style={styles.link}>SAR Log</Link>
          </>
        )}
      </div>

      <button onClick={handleLogout} style={styles.logout}>
        Logout
      </button>
    </nav>
  );
}

const styles = {
  nav: {
    display: "flex",
    justifyContent: "space-between",
    padding: "10px 20px",
    background: "#4a90e2",
    color: "white",
    marginBottom: "20px"
  },
  left: {
    display: "flex",
    gap: "20px",
    alignItems: "center"
  },
  link: {
    color: "white",
    textDecoration: "none",
    fontWeight: "bold"
  },
  logout: {
    background: "white",
    color: "#4a90e2",
    border: "none",
    padding: "6px 12px",
    borderRadius: "4px",
    cursor: "pointer",
    fontWeight: "bold"
  }
};